import { FC, useState } from 'react';
import {
  useAvailableOrganisations,
  useMutateAdminUserOrganisation,
} from 'hooks/data/adminUser/useOrganisationMemberships';
import Button from 'components/Button';
import RecordView from 'components/RecordView';
import FieldRow from 'components/FormElements/FieldRow';
import BasicSelect from 'further-ui/components/BasicSelect';
import { Box } from '@mui/material';

type Props = {
  adminUserId: string;
  currentOrgMemberships: Array<string>;
};

const AddOrganisationMembership: FC<Props> = ({
  adminUserId,
  currentOrgMemberships,
}) => {
  const [auth0OrgId, setAuth0OrgId] = useState<string>();
  const [auth0RoleId, setAuth0RoleId] = useState<string>();

  const { data: allOrganisations } = useAvailableOrganisations();
  const { create } = useMutateAdminUserOrganisation(adminUserId);

  const onSelectOrganisation = (id: string) => {
    setAuth0OrgId(id);
    setAuth0RoleId(undefined);
  };

  const addUserToOrganisation = () => {
    create.mutate(
      //@ts-expect-error
      { auth0OrgId, auth0RoleId },
      {
        onSuccess: () => {
          setAuth0OrgId(undefined);
          setAuth0RoleId(undefined);
        },
      },
    );
  };

  const availableRoles = allOrganisations?.find(
    (org) => org.auth0OrgId === auth0OrgId,
  )?.roles;

  const availableOrganisations = allOrganisations?.filter(
    (org) => !currentOrgMemberships.includes(org.auth0OrgId),
  );

  return (
    <RecordView>
      <FieldRow title="Organisation">
        <BasicSelect
          options={
            availableOrganisations?.map((org) => ({
              label: org.firmName ?? '',
              value: org.auth0OrgId,
            })) ?? []
          }
          value={auth0OrgId}
          onChange={onSelectOrganisation}
          fullWidth
          placeholder="Select organisation"
          noOptionsMessage="No organisations available"
        />
      </FieldRow>
      <FieldRow title="Role">
        <Box display="flex" gap={4}>
          <BasicSelect
            value={auth0RoleId}
            onChange={setAuth0RoleId}
            options={
              availableRoles?.map((role) => ({
                label: role.name,
                value: role.auth0RoleId,
                description: role.description ?? '-',
              })) ?? []
            }
            disabled={!auth0OrgId}
            fullWidth
            noOptionsMessage="No roles available"
            placeholder="Select role"
          />
          <Button
            variant="contained"
            disabled={!auth0OrgId || !auth0RoleId || create.isPending}
            onClick={addUserToOrganisation}
          >
            Add
          </Button>
        </Box>
      </FieldRow>
    </RecordView>
  );
};

export default AddOrganisationMembership;
